import { Box, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { textComponentThemes } from '../../../theme/textComponentThemes';

interface VoteAvailabilityBoxProps {
  availableVotes: number;
  usedVotes: number;
  voteLimit: number;
  textColor?: string;
}

const VoteAvailabilityBox = ({
  availableVotes,
  usedVotes,
  voteLimit,
  textColor,
}: VoteAvailabilityBoxProps) => {
  const theme = useTheme();
  const isSmallWindow = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Typography
      variant="h6"
      sx={{
        m: 0,
        color:
          availableVotes > 0
            ? textColor ?? textComponentThemes.votes_available.textColor
            : isSmallWindow
            ? '#ffffff'
            : textComponentThemes.votes_unavailable.textColor,
        fontSize: textComponentThemes.votes_available.fontSize,
        fontWeight: textComponentThemes.votes_available.fontWeight,
      }}
    >
      {availableVotes} vote{availableVotes !== 1 ? 's' : ''} available
    </Typography>
  );
};

export default VoteAvailabilityBox;
